import { createFileRoute } from '@tanstack/react-router';

import { PostCardPreview } from '#modules/finder/components/PostCardPreview';

/**
 * Сравнение карточки заявки: текущая версия рядом с отполированной, на настоящих заявках.
 * Временный экран, живёт рядом с другими превью и удаляется вместе с компонентом.
 *
 * `ssr: false`: лента меняется между визитами, серверный рендер её не переиспользует.
 */
export const Route = createFileRoute('/{-$locale}/_layout/preview/post-card')({
  component: PostCardPreview,
  ssr: false,
});
